import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { MetaService } from '@shared/services/meta/meta.service';
import { HelixBookRepositoryService } from '../../services/helix-book-repository.service';
import { MobileSearchModalComponent } from '../../components/mobile-search-modal/mobile-search-modal.component';
import { DescriptionPage } from '../../enums/description.enums';
import { Tab } from '../../enums/tabs.enums';
import { NzTabChangeEvent } from 'ng-zorro-antd/tabs';
import { KbItemType } from '@medindex-webapi';
import { BreadcrumbItem } from '@shared/modules/breadcrumb/types/breadcrumbItem';
import { Subject, map } from 'rxjs';

@Component({
  selector: 'app-helix-book',
  templateUrl: './helix-book.component.html',
  styleUrls: ['./helix-book.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HelixBookRepositoryService],
})
export class HelixBookComponent implements OnInit, OnDestroy {
  constructor(
    public repository: HelixBookRepositoryService,
    private metaService: MetaService
  ) {}

  ngUnsubscribe$ = new Subject<void>();
  breadcrumbs: BreadcrumbItem[] = [
    { href: '/', text: 'Главная' },
    { href: '', text: DescriptionPage.Title },
  ];

  readonly DescriptionPage = DescriptionPage;
  readonly Tab = Tab;
  readonly MobileSearchModalComponent = MobileSearchModalComponent;

  ngOnInit(): void {
    this.repository.loadList();
    this.metaService.title(this.DescriptionPage.Title);
    this.metaService.description(this.DescriptionPage.MetaDescription);
  }

  setTab(args: NzTabChangeEvent[]): void {
    const [tab] = args;
    const title = tab.tab.nzTitle;

    switch (title) {
      case Tab.Analyzes:
        this.repository.setTab(KbItemType.Analyse);
        break;
      case Tab.Diseases:
        this.repository.setTab(KbItemType.Disease);
        break;
      case Tab.GlossaryTerms:
        this.repository.setTab(KbItemType.GeneticDictionary);
        break;
      default: {
        break;
      }
    }
  }

  tabIndex$ = this.repository.activeTab$.pipe(
    map((tab) => {
      switch (tab) {
        case KbItemType.Analyse:
          return 0;
        case KbItemType.Disease:
          return 1;
        case KbItemType.GeneticDictionary:
          return 2;
      }
    })
  );

  ngOnDestroy(): void {
    this.repository.setActiveKey('');
  }
}
